const fnSlide = (() => {
  const pageFamilyNature = (document.getElementById("pageFamilyNature") != null);
  if (pageFamilyNature) {


    let sW = window.innerWidth;

    let slidesPerView;
    let spaceBetween;

    if (sW > 750) {
      slidesPerView = 1.4
      spaceBetween = 40
    } else {
      slidesPerView = 1.3
      spaceBetween = 20
    }

    {
      const swiper = new Swiper("#jsSwiper1", {
        loop: true,
        centeredSlides: true,
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        speed: 800,
        navigation: {
          nextEl: ".swiper-btn-next",
          prevEl: ".swiper-btn-prev"
        }
      });

      let swiperCopy = document.getElementById("jsSwiper1Copy")
      let time = swiperCopy.querySelector('.js-time');
      let who = swiperCopy.querySelector('.js-who');
      let todo = swiperCopy.querySelector('.js-todo');
      let txt = swiperCopy.querySelector('.js-txt');
      swiper.on('slideChange', function () {
        if (swiper.realIndex == 0) {
          time.textContent = `7:30`;
          who.textContent = `#夫`;
          todo.textContent = `出勤`;
          txt.textContent = `広島高速4号線を通るルートになってから、渋滞に巻き込まれることがなく、通勤時間は短縮。職場へと向かう気持ちを整える、ちょうどいい距離感も快適だ。`;
        } else if (swiper.realIndex == 1) {
          time.textContent = `8:20`;
          who.textContent = `#妻・子`;
          todo.textContent = `保育園`;
          txt.textContent = `子どもたちを保育園に送り出し。自然とふれあえて、広い園庭でのびのびと遊べる子どもたちは毎日楽しそう。団地内の道幅が広くて、自転車通園もラクになったな。`;
        } else if (swiper.realIndex == 2) {
          time.textContent = `9:00`;
          who.textContent = `#妻`;
          todo.textContent = `リモートワーク`;
          txt.textContent = `リモートワークの日は、スタディルームが私のワークスペース。保育園から息子が帰ったら、小学校入学に向けて今度は一緒にお勉強。`;
        } else if (swiper.realIndex == 3) {
          time.textContent = `17:00`;
          who.textContent = `#妻・子`;
          todo.textContent = `お出迎え・買い物`;
          txt.textContent = `子どもたちのお迎えとあわせて、一緒にフレスポへ買い出しに。スーパーはいつも新鮮な野菜がたくさん。ドラッグストアが隣接してるから日用品の買い足しもラクラク。`;
        } else if (swiper.realIndex == 4) {
          time.textContent = `19:30`;
          who.textContent = `#家族`;
          todo.textContent = `夕食`;
          txt.textContent = `その日の出来事を語り合う大切な家族の時間。子どもたちは今日、園の裏山でぼうけんごっこをしたみたい。ここに越してから家での食事はもちろん、笑顔と会話が本当に増えたな。`;
        }
      });
    }
    {
      const swiper = new Swiper("#jsSwiper2", {
        loop: true,
        centeredSlides: true,
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        speed: 800,
        navigation: {
          nextEl: ".swiper-btn-next",
          prevEl: ".swiper-btn-prev"
        }
      });

      let swiperCopy = document.getElementById("jsSwiper2Copy")
      let time = swiperCopy.querySelector('.js-time');
      let who = swiperCopy.querySelector('.js-who');
      let todo = swiperCopy.querySelector('.js-todo');
      let txt = swiperCopy.querySelector('.js-txt');
      swiper.on('slideChange', function () {
        if (swiper.realIndex == 0) {
          time.textContent = `7:00`;
          who.textContent = `#妻`;
          todo.textContent = `ピラティス`;
          txt.textContent = `朝のルーティーンは心身を整えるピラティスからスタート。広々バルコニーでカラダを解放し、空と緑と湖と、自然と重なるように深まる呼吸が最高に気持ちいい！`;
        } else if (swiper.realIndex == 1) {
          time.textContent = `9:00`;
          who.textContent = `#家族`;
          todo.textContent = `朝食・カフェ`;
          txt.textContent = `休日は家族そろって近所の「尾道浪漫珈琲」でモーニング。子どもたちはここのフルーツワッフルが大好き。いつ来ても、ゆったりとしたお店の雰囲気に癒されるなあ。`;
        } else if (swiper.realIndex == 2) {
          time.textContent = `9:50`;
          who.textContent = `#家族`;
          todo.textContent = `お出掛け`;
          txt.textContent = `家族で出かける時は、もっぱら子どもたちがのびのびと遊べる場所へ。家の近くも公園がたくさんだけど、少し足を伸ばせば自然に囲まれたスポットへ行けるので、週末が楽しみに。`;
        } else if (swiper.realIndex == 3) {
          time.textContent = `12:10`;
          who.textContent = `#家族`;
          todo.textContent = `キャンプ`;
          txt.textContent = `楽しみにしていたキャンプ。西風新都ICがすぐなので中国5県が移動範囲に。今回は県北の涼しい場所を選んだけど、次はどこのオートキャンプ場へ行くかをすでに計画中。`;
        }
      });
    }



  }
})();
export default fnSlide;